import {Separator} from 'platform/components';
import {Box, HStack, Hide, Space, Text} from 'platform/foundation';

export const HeaderCell = (props: {isFirst?: boolean; label: string}) => (
  <Box paddingVertical={2} backgroundColor="palettes.neutral.10.100">
    <HStack>
      <Hide when={props.isFirst}>
        <Separator orientation="vertical" spacing={0} />
      </Hide>

      <Space horizontal={2} />

      <Text align="left" alternative>
        {props.label}
      </Text>
    </HStack>
  </Box>
);
